import React from "react";

function PartnerPayments() {
  const payments = [
    {
      id: "PAY-001",
      project: "Java DSA Training",
      trainer: "Rahul Sharma",
      amount: "₹40,000",
      status: "PAID",
    },
    {
      id: "PAY-002",
      project: "Python Training",
      trainer: "Amit Kumar",
      amount: "₹35,000",
      status: "PENDING",
    },
  ];

  return (
    <div className="page">
      <h1>Partner Payments</h1>
      <p>Manage your training and trainer payments.</p>

      <div className="stats">
        <div>
          <span>Total Paid</span>
          <strong>₹75,000</strong>
        </div>

        <div>
          <span>Pending</span>
          <strong>₹35,000</strong>
        </div>

        <div>
          <span>Total Transactions</span>
          <strong>2</strong>
        </div>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Payment ID</th>
              <th>Project</th>
              <th>Trainer</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {payments.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.project}</td>
                <td>{item.trainer}</td>
                <td>{item.amount}</td>
                <td>
                  <span className={item.status === "PAID" ? "paid" : "pending"}>
                    {item.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .page {
          padding:30px;
          background:#f8fafc;
          min-height:100vh;
        }

        .page > p {
          color:#64748b;
        }

        .stats {
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:20px;
          margin:25px 0;
        }

        .stats div {
          background:white;
          padding:22px;
          border-radius:12px;
          box-shadow:0 4px 15px rgba(0,0,0,.06);
        }

        .stats span {
          display:block;
          color:#64748b;
          font-size:13px;
        }

        .stats strong {
          display:block;
          margin-top:8px;
          font-size:24px;
          color:#2563eb;
        }

        .card {
          background:white;
          padding:20px;
          border-radius:12px;
          overflow:auto;
        }

        table {
          width:100%;
          border-collapse:collapse;
        }

        th,td {
          padding:13px;
          border-bottom:1px solid #e2e8f0;
          text-align:left;
        }

        th {
          background:#f8fafc;
        }

        .paid,
        .pending {
          padding:5px 10px;
          border-radius:20px;
          font-size:11px;
          font-weight:bold;
        }

        .paid {
          background:#dcfce7;
          color:#166534;
        }

        .pending {
          background:#fef3c7;
          color:#92400e;
        }

        @media(max-width:700px) {
          .stats {
            grid-template-columns:1fr;
          }
        }
      `}</style>
    </div>
  );
}

export default PartnerPayments;